<template>
  <div class="container-fluid">
    <div class="row select">
      <div class="col-md-12 select-choices" :class="{editable: isEditable}">
        <draggable
          class="choice-container"
          group="choices"
          ghost-class="choice-ghost"
          draggable=".draggable"
          v-model="computedValue"
        >
          <select-choice-item
            v-for="choice in computedValue"
            :key="choice.id"
            :choice="choice"
            :question="question"
            :class="{draggable: isEditable}"
            :isEditable="isEditable"
            @onUpdateChoice="handleUpdateChoice"
            @onEmpty="handleRemove(choice.id)"
            @onRemove="handleRemove(choice.id)"
          ></select-choice-item>
          <div slot="footer" v-if="isEditable">
            <div class="placeholder-container">
              Drag choice or
              <a @click="handleCreateChoice">Create a new choice</a>
            </div>
          </div>
        </draggable>
      </div>
      <div class="options">
        <el-button size="mini" @click="handleClear" v-if="isEditable">
          <i class="fa fa-trash"></i> &nbsp; Clear all choices
        </el-button>
        <el-button size="mini" :disabled="!isValid" @click="handleSaveTemplate">
          <i class="fa fa-save"></i> &nbsp; Save as new Choice Template
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

import Empty from '@/components/common/Empty';

import { emptyChoice, parseChoices } from '../../utils';
import SelectChoiceItem from './SelectChoiceItem';

export default {
  name: 'SelectEditorExpanded',
  components: {
    draggable,

    Empty,

    SelectChoiceItem,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    question: {
      type: Object,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    isModified: false,
    hasSavedTemplate: false,
  }),
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(values) {
        const choices = parseChoices(values);
        this.$emit('input', choices);
      },
    },

    isValid() {
      return this.computedValue.length > 0 && this.computedValue.every(c => c !== '');
    },
  },
  beforeDestroy() {
    if (this.isModified && this.computedValue.length > 0 && !this.hasSavedTemplate) {
      this.$confirm(
        'Do you want to save this group of choices to use again in future with other questions?',
        'Save as choice template?',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'info',
        },
      ).then(this.handleSaveTemplate);
    }
  },
  methods: {
    handleRemove(choiceId) {
      const filteredChoices = this.value.filter(c => c.id !== choiceId);
      this.$emit('input', filteredChoices);
    },

    handleClear() {
      this.$emit('input', []);
    },

    handleUpdateChoice(choice) {
      this.isModified = true;
      this.computedValue = this.computedValue.map(c => {
        if (c.id === choice.id) {
          return choice;
        }
        return c;
      });
    },

    handleCreateChoice() {
      this.computedValue = [...this.computedValue, emptyChoice()];
    },

    handleSaveTemplate() {
      this.hasSavedTemplate = true;
      this.$store.dispatch('surveybuilder/choiceTemplateShowCreateDialog', {
        choices: this.computedValue,
        isScale: false,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.select-choices.editable {
  margin-bottom: 40px;
}

.choice-container {
  min-height: 65px;
}

.draggable {
  cursor: grab;
}

.placeholder-container {
  position: absolute;
  border: 2px dashed #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  text-shadow: 2px 2px 2px #efefef;
  font-size: 0.8em;
  color: #ccc;
  min-height: 40px;
  margin: 0;
  width: calc(100% - 30px);
  z-index: 0;
}

.options {
  float: right;
  margin: 10px 12px 0 0;
}
</style>

<style>
.choice-ghost {
  position: relative;
  z-index: 10;
  margin: 6px 2px;
}
</style>



// WEBPACK FOOTER //
// SelectEditorExpanded.vue?f81011d6